import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

export default function Button({
	children,
	background,
	uppercase,
	wide,
	transparent,
	linkTo,
	alignCenter,
	noHover,
}) {
	const history = useHistory();

	const onClick = () => {
		if (linkTo) {
			linkTo[0] === "/" ? history.push(linkTo) : window.open(linkTo);
		}
	};

	return (
		<ButtonContainer
			background={background}
			uppercase={uppercase}
			wide={wide}
			transparent={transparent}
			alignCenter={alignCenter}
			onClick={onClick}
			noHover={noHover}
		>
			{children || "subscribe"}
		</ButtonContainer>
	);
}

const ButtonContainer = styled.button.attrs((props) => ({
	className: "btn-btn",
	type: "submit",
}))`
	padding: ${(props) => (props.wide ? "1rem 3.9rem" : "1rem 1.8rem")};
	margin: ${(props) => props.alignCenter && "auto"};

	border: ${(props) => props.transparent && "0.7px solid #024CA3"};
	background-color: ${(props) =>
		props.transparent ? "transparent" : props.background || "#024CA3"};
	color: ${(props) => (props.transparent ? "#024CA3" : "white")};
	font-size: 0.9rem;
	font-weight: 500;
	text-transform: ${(props) => (props.uppercase ? "uppercase" : "initial")};
	cursor: pointer;

	&:hover {
		border: ${(props) => !props.transparent && "0.7px solid #024CA3"};
		background-color: ${(props) =>
			!props.transparent ? "transparent" : props.background || "#024CA3"};
		color: ${(props) => (!props.transparent ? "#024CA3" : "white")};
		padding: ${(props) => !props.transparent && ".95rem 1.8rem"};
		padding: ${(props) =>
			!props.transparent && props.wide && ".95rem 3.9rem"};
	}

	&:hover {
		border: ${(props) => props.noHover && "none"};
		background-color: ${(props) => props.noHover && "#024CA3"};
		color: ${(props) => props.noHover && "white"};
	}

	@media (max-width: 768px) {
		padding: ${(props) => (props.wide ? "0.8rem 1.9rem" : "0.8rem 1.6rem")};
		font-size: 0.8rem;
	}
`;
